module.exports = __webpack_public_path__ + "img/DE00828.5c9cdf2b.png";